<template>
  <div class='RegisterClient'>
    <div class="btn-add">
      <button
      v-if="$route.path !== '/painel/client/edit'"
      @click="push"
      >
      Adicionar
      </button>
      <button
      v-if="$route.path === '/painel/client/edit'"
      @click="update"
      >
      Atualizar
      </button>
    </div>
    <div class="block">
      <input-reg
      :value="SelectedClientEdit.usuario.usuario"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { usuario: newValue } })"
      text="Usuário"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :error="ClientValidate.usuario.$invalid"
      :errorMsg="ClientValidate.usuario.has.$invalid ? ClientValidate.usuario.has.$message : ''"
      v-if="$route.path !== '/painel/client/edit'"
      />
      <input-reg
      :value="SelectedClientEdit.usuario.email"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { email: newValue }})"
      text="Email"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :error="ClientValidate.email.$invalid"
      :errorMsg="ClientValidate.email.has.$invalid ? ClientValidate.email.has.$message : ''"
      v-if="$route.path !== '/painel/client/edit'"
      />
    </div>
    <div class="block">
      <input-reg
      :value="SelectedClientEdit.usuario.nome"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { nome: newValue }})"
      text="Primeiro nome"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :error="ClientValidate.nome.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.usuario.sobrenome"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { sobrenome: newValue }})"
      text="Sobrenome"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :error="ClientValidate.sobrenome.$invalid"
      />
    </div>
    <div class="block">
      <input-reg
      :value="SelectedClientEdit.endereco.cpf"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { cpf: newValue }})"
      text="CPF"
      :cont="{ width: '30%', paddingLeft: '0.6%' }"
      :label="{ textAlign: 'left', marginLeft: '1%' }"
      :input="{ fontSize: '20px', padding: '2.4%', width: '94%', borderRadius: '5px' }"
      :Mask="['###.###.###-##']"
      :error="ClientValidate.cpf.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.celular"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { celular: newValue }})"
      text="Celular"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '3%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '92%', borderRadius: '5px' }"
      :Mask="['(##) #####-####', '(##) ####-####']"
      :error="ClientValidate.celular.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.cep"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { cep: newValue }})"
      text="CEP"
      :cont="{ width: '18.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '4%', width: '92%', borderRadius: '5px' }"
      :Mask="['#####-###']"
      :error="ClientValidate.cep.$invalid"
      />
    </div>
    <div class="block">
      <input-reg
      :value="SelectedClientEdit.endereco.bairro"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { bairro: newValue }})"
      text="Bairro"
      :cont="{ width: '30%', paddingLeft: '0.6%' }"
      :label="{ textAlign: 'left', marginLeft: '1%' }"
      :input="{ fontSize: '20px', padding: '2.4%', width: '94%', borderRadius: '5px' }"
      :error="ClientValidate.bairro.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.endereco"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { endereco: newValue }})"
      text="Endereço"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '3%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '92%', borderRadius: '5px' }"
      :error="ClientValidate.endereco.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.numero"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { numero: newValue }})"
      text="Número"
      :cont="{ width: '18.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '4%', width: '92%', borderRadius: '5px' }"
      :Mask="['########']"
      :error="ClientValidate.numero.$invalid"
      />
    </div>
    <div class="block">
      <input-reg
      :value="SelectedClientEdit.endereco.cidade"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { cidade: newValue }})"
      text="Cidade"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :error="ClientValidate.cidade.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.uf"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { uf: newValue }})"
      text="Estado(UF)"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :Mask="['AA']"
      :error="ClientValidate.uf.$invalid"
      />
    </div>
    <div class="block">
      <input-reg
      :value="SelectedClientEdit.usuario.senha"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { senha: newValue }})"
      text="Senha"
      type="password"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :error="ClientValidate.senha.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.usuario.csenha"
      @update:model-value="newValue => ChangeClientEdit({ usuario: { csenha: newValue }})"
      text="Confirmar senha"
      type="password"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      :error="ClientValidate.csenha.$invalid"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputReg from '../../Produtos/Register/InputReg'
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, helpers } from '@vuelidate/validators'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'RegisterClient',
  components: { InputReg },
  computed: {
    ...mapGetters(['SelectedClientEdit', 'ClientValidate']),
    usuario () {
      return this.SelectedClientEdit.usuario.usuario
    },
    email () {
      return this.SelectedClientEdit.usuario.email
    },
    nome () {
      return this.SelectedClientEdit.usuario.nome
    },
    sobrenome () {
      return this.SelectedClientEdit.usuario.sobrenome
    },
    cpf () {
      return this.SelectedClientEdit.endereco.cpf
    },
    celular () {
      return this.SelectedClientEdit.endereco.celular
    },
    cep () {
      return this.SelectedClientEdit.endereco.cep
    },
    bairro () {
      return this.SelectedClientEdit.endereco.bairro
    },
    endereco () {
      return this.SelectedClientEdit.endereco.endereco
    },
    numero () {
      return this.SelectedClientEdit.endereco.numero
    },
    cidade () {
      return this.SelectedClientEdit.endereco.cidade
    },
    uf () {
      return this.SelectedClientEdit.endereco.uf
    },
    senha () {
      return this.SelectedClientEdit.usuario.senha
    },
    csenha () {
      return this.SelectedClientEdit.usuario.csenha
    }
  },
  methods: {
    ...mapActions(['setClientValidate', 'ChangeClientEdit', 'PushClientPainel', 'UpdateClient', 'VerifyUserEmailHas']),
    async push () {
      let valid = await this.v$.$validate()
      this.setClientValidate(this.v$)
      if(!valid) {
        return
      }
      console.log(this.SelectedClientEdit, 'this.SelectedClientEdit')
      this.PushClientPainel(this.SelectedClientEdit)
    },
    async update () {
      if(
        this.v$.nome.$invalid ||
        this.v$.sobrenome.$invalid ||
        this.v$.cpf.$invalid ||
        this.v$.celular.$invalid ||
        this.v$.cep.$invalid ||
        this.v$.bairro.$invalid ||
        this.v$.endereco.$invalid ||
        this.v$.numero.$invalid ||
        this.v$.cidade.$invalid ||
        this.v$.uf.$invalid ||
        this.v$.senha.$invalid ||
        this.v$.csenha.$invalid
      ) {
        this.setClientValidate(this.v$)
        return
      }
      this.UpdateClient(this.SelectedClientEdit)
    },
    async userHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.user) },
    async emailHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.email) }
  },
  validations () {
    return {
      usuario: {
        required,
        minLength: minLength(4),
        has: helpers.withMessage('Nome de usuário não disponível', helpers.withAsync(this.userHas))
      },
      email: {
        required,
        email,
        has: helpers.withMessage('Email não disponível', helpers.withAsync(this.emailHas))
      },
      nome: {
        required
      },
      sobrenome: {
        required
      },
      cpf: {
        required,
        minLength: minLength(14)
      },
      celular: {
        required,
        minLength: minLength(15)
      },
      cep: {
        required,
        minLength: minLength(9)
      },
      bairro: {
        required
      },
      endereco: {
        required
      },
      numero: {
        required
      },
      cidade: {
        required
      },
      uf: {
        required,
        minLength: minLength(2)
      },
      senha: {
        required,
        minLength: minLength(6)
      },
      csenha: {
        required,
        minLength: minLength(6),
        sameAs: (s) => s === this.senha
      }
    }
  }
}
</script>

<style scoped>
.btn-add {
  display: flex;
  justify-content: end;
  padding-right: 1.3%;
}

.block {
  display: flex;
  padding: 0.5%;
}

button {
  border: 0;
  font-size: 16px;
  padding: 1%;
  border-radius: 5px;
  background-color: #333333;
  color: #FFFFFF;
  cursor: pointer;
}
</style>
